import { useMutation } from '@tanstack/react-query'
import { DHL_API } from '../../api'
import { DamageDuringRouteRequest } from './types'

async function sendDamageDuringRouteData(data: DamageDuringRouteRequest) {
  const response = await DHL_API.post(
    'api/fleet/storegear/vehicles/damages/en-route',
    data
  )
  return response.data
}

export function useSendDamageDuringRoute() {
  return useMutation((data: DamageDuringRouteRequest) =>
    sendDamageDuringRouteData(data)
  )
}
